import { css, cva } from '@/styled-system/css';

export const menuContentRecipe = cva({
  base: {
    borderRadius: 'obj.soft',
    backgroundColor: 'bg.elevated.mediumShadow',
    boxShadow: 'md',
    position: 'relative',
    overflow: 'hidden',
    minWidth: '200px',
    maxWidth: '360px',
    // Reset browser defaults for <ul>
    listStyle: 'none',
    margin: 0,
    padding: 0,
    transitionProperty: {
      _motionReduce: 'none',
      _motionSafe: 'opacity, transform',
    },
    transitionDuration: {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}',
    },
    transitionTimingFunction: '{easings.ease}',
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
        transform: 'scale(0.975)',
      },
    },
    dividers: {
      true: {
        '& .c11n_menu__group:not(:last-child)': {
          borderBottomWidth: 'default',
          borderBottomStyle: 'solid',
          borderBottomColor: 'Menu.Group.border',
        },
      },
      false: {},
    },
  },
});

export const menuContentPositionerStyles = css.raw({
  zIndex: 'menu',
});
